import { ykDateFormat } from '@/public/utils/globalFunc.js'
import XEUtils from 'xe-utils'
// 日期
export function VDate(el, binding, vnode) {
  const value = ykDateFormat('yyyy-MM-dd', vnode.data.model.value)
  vnode.data.model.callback(value)
}
// 时间
export function VDatetime(el, binding, vnode) {
  const value = ykDateFormat('yyyy-MM-dd HH:mm:ss', vnode.data.model.value)
  vnode.data.model.callback(value)
}

// 监听按下键盘，失去焦点，实现只读的功能，但是可通过clearable清除数据
export function VReadonly(el) {
  const element = el.getElementsByTagName('input')[0]
  element.setAttribute('readOnly', true)
}

// 金额 - app
export function VAppMoney(el, binding, vnode) {
  const len = binding.arg
  const ifShow = binding.value
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input')
    if (els.length === 1) {
      el = els[0]
    }
  }
  // el.style['text-align'] = 'right'
  if (ifShow) {
    let value = vnode.data.model.value
    value = parseFloat(value)
    if (el.focus !== true) {
      setTimeout(() => {
        if (isNaN(value)) {
          el.value = !vnode.data.model.value ? '' : vnode.data.model.value
        } else {
          el.value = XEUtils.commafy(parseFloat(value), {
            digits: len
          })
        }
      }, 10)
    }
  } else {
    if (el.focus !== true) {
      setTimeout(() => {
        el.value = '***'
      }, 5)
    }
  }
  el.onblur = function() {
    el.focus = false
    if (ifShow) {
      let value = vnode.data.model.value
      if (parseFloat(value).toString() === 'NaN') {
        return
      }
      value = value.toString().replace(/,/g, '')
      if (!isNaN(value)) {
        const arr = value.toString().split('.')
        if (arr.length > 1 && arr[1].length > len) {
          value = parseFloat(value).toFixed(len)
        }
        vnode.data.model.callback(value)
        setTimeout(() => {
          el.value = XEUtils.commafy(parseFloat(value), {
            digits: len
          })
        }, 5)
      }
    } else {
      el.value = '***'
    }
  }
  el.onfocus = function() {
    el.focus = true
    if (ifShow) {
      let value = el.value
      value = value.toString().replace(/,/g, '')
      if (parseFloat(value).toString() === 'NaN') {
        return
      }
      if (!isNaN(value)) {
        el.value = value
      }
    }
  }
}
// 金额
export function VMoney(el, binding, vnode) {
  const len = binding.arg
  const ifShow = binding.value
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input')
    if (els.length === 1) {
      el = els[0]
    }
  }
  el.style['text-align'] = 'right'
  if (ifShow) {
    let value = vnode.data.model.value
    value = parseFloat(value)
    if (el.focus !== true) {
      setTimeout(() => {
        if (isNaN(value)) {
          el.value = !vnode.data.model.value ? '' : vnode.data.model.value
        } else {
          el.value = XEUtils.commafy(parseFloat(value), {
            digits: len
          })
        }
      }, 10)
    }
  } else {
    if (el.focus !== true) {
      setTimeout(() => {
        el.value = '***'
      }, 5)
    }
  }
  el.onblur = function() {
    el.focus = false
    if (ifShow) {
      let value = vnode.data.model.value
      if (parseFloat(value).toString() === 'NaN') {
        return
      }
      value = value.toString().replace(/,/g, '')
      if (!isNaN(value)) {
        const arr = value.toString().split('.')
        if (arr.length > 1 && arr[1].length > len) {
          value = parseFloat(value).toFixed(len)
        }
        vnode.data.model.callback(value)
        setTimeout(() => {
          el.value = XEUtils.commafy(parseFloat(value), {
            digits: len
          })
        }, 5)
      }
    } else {
      el.value = '***'
    }
  }
  el.onfocus = function() {
    el.focus = true
    if (ifShow) {
      let value = el.value
      value = value.toString().replace(/,/g, '')
      if (parseFloat(value).toString() === 'NaN') {
        return
      }
      if (!isNaN(value)) {
        el.value = value
      }
    }
  }
}
// 金额(大写)
export function VMoneyInWords(el, binding, vnode) {
  // console.log(el, binding, vnode)
  const ifShow = binding.value
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input')
    if (els.length === 1) {
      el = els[0]
    }
  }
  if (!ifShow) {
    setTimeout(() => {
      el.value = '***'
    }, 10)
  } else {
    let value = vnode.data.model.value
    setTimeout(() => {
      el.value = value
    }, 10)
  }
}
// 单价
export function VPrice(el, binding, vnode) {
  // console.log(el, binding, vnode)
  const ifShow = binding.value
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input')
    if (els.length === 1) {
      el = els[0]
    }
  }
  if (!ifShow) {
    setTimeout(() => {
      el.value = '***'
    }, 10)
  } else {
    let value = vnode.data.model.value
    value = value.toString().replace(',', '')
    setTimeout(() => {
      el.value = value
    }, 10)
  }
}
